'use strict'
import { useState } from 'react'
// @mui material components
import Card from '@mui/material/Card'
import Icon from '@mui/material/Icon'
import Grid from '@mui/material/Grid'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import Stack from '@mui/material/Stack'
// import Menu from '@mui/material/Menu'
// import MenuItem from '@mui/material/MenuItem'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDSnackbar from 'components/MDSnackbar'
import MDButton from 'components/MDButton'

// Material Dashboard 2 PRO React example components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import Footer from 'components/Footer'

// zerouno
import addressService from 'services/address.service'
import { useParams, Link } from 'react-router-dom'
import ZUTitleForm from 'components/ZeroUno/ZUTitleForm'
import RegistryNav from './RegistryNav'
import ZuDataTable from 'components/ZeroUno/ZuDataTable'

export default function AddressTable() {
  const [objId, setObjId] = useState(0)
  const { idRegistry } = useParams()
  // const [obj, setObj] = useState([])
  // const [objects, setObjects] = useState([])
  const [showSnackbar, setShowSnackbar] = useState({
    sh: false,
    msg: '',
    color: 'success'
  })
  const [openConfirm, setOpenConfirm] = useState(false)
  const { data: objects, isLoading, error } = addressService.getAll(idRegistry)

  // Delete
  const deleteObject = () => {
    setOpenConfirm(false)
    addressService.remove(idRegistry, objId).then(
      (response) => {
        setShowSnackbar({
          sh: true,
          msg: 'operazione effettuata con successo',
          color: 'success'
        })
        addressService.refresh(idRegistry)
        // fetchObjects()
      },
      (error) => {
        setShowSnackbar({
          sh: true,
          msg: error.response
            ? error.response.data.message
            : 'errore di ricezione dati',
          color: 'error'
        })
      }
    )
  }

  const columns = [
    {
      header: 'principale',
      accessorKey: 'main',
      Cell: ({ cell }) =>
        cell.getValue() ? <CheckBoxIcon color='primary' /> : ''
    },
    {
      header: 'indirizzo',
      accessorKey: 'address'
    },
    {
      header: 'num',
      accessorKey: 'civicNumber'
    },
    {
      header: 'città',
      accessorKey: 'city'
    },
    {
      header: 'tel',
      accessorKey: 'phone'
    },
    {
      header: 'azioni',
      enableSorting: false,
      enableColumnFilter: false,
      size: 100,
      accessorKey: 'id',
      Cell: ({ cell }) => (
        <Grid container spacing={1}>
          <Grid item>
            <MDButton
              color='info'
              size='small'
              iconOnly
              component={Link}
              to={`/registries/${idRegistry}/addresses/${cell.getValue()}`}
            >
              <Icon>edit</Icon>
            </MDButton>
          </Grid>
          <Grid item>
            <MDButton
              iconOnly
              color='error'
              size='small'
              onClick={() => {
                setObjId(cell.getValue())
                setOpenConfirm(true)
              }}
            >
              <Icon>delete</Icon>
            </MDButton>
          </Grid>
        </Grid>
      )
    }
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={10}>
            <Card>
              <ZUTitleForm bgColor='info' title='Indirizzi' icon='place' />
              <MDBox p={3} lineHeight={1}>
                <MDButton
                  color='secondary'
                  component={Link}
                  to='/registries'
                  sx={{ m: 1 }}
                >
                  indietro
                </MDButton>
                <MDButton
                  color='info'
                  component={Link}
                  to={`/registries/${idRegistry}/addresses/new`}
                  m={1}
                >
                  nuovo
                </MDButton>
              </MDBox>
              <ZuDataTable table={{ columns: columns, rows: objects }} />
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={2}>
            <RegistryNav id={idRegistry} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          Confermi eliminazione?
        </DialogTitle>
        <DialogActions>
          <MDButton onClick={() => setOpenConfirm(false)}>Annulla</MDButton>
          <MDButton onClick={deleteObject} autoFocus>
            Conferma
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDSnackbar
        color={showSnackbar.color}
        icon='notifications'
        title='Notifica'
        content={showSnackbar.msg}
        dateTime='adesso'
        open={showSnackbar.sh}
        autoHideDuration={5000}
        close={() => setShowSnackbar({ sh: false, msg: '', color: 'info' })}
      />
    </DashboardLayout>
  )
}
